import { useMemo } from 'react';
import {
  FINANCIAL_INSTITUTION_SLUG,
  findQuestionBySlug,
  getQuestionsFromList,
} from '@/modules/financials/utils';

const useFinancialInstitutionQuestion = (mainQuestionsData) =>
  useMemo(
    () =>
      findQuestionBySlug(
        mainQuestionsData?.list
          ? getQuestionsFromList(mainQuestionsData.list)
          : mainQuestionsData?.questions || [],
        FINANCIAL_INSTITUTION_SLUG
      ),
    [mainQuestionsData]
  );

export default useFinancialInstitutionQuestion;
